<template>
  <Dialog class="role-input" :open="isOpen" hide-title>
    <div class="content">
      <div class="input-area">
        <textarea v-model="info" placeholder="请粘贴从游戏内获得的角色信息" />
      </div>
      <div @click="confirm" class="btn-area"></div>
      <div class="close-area" @click="close"></div>
      <div @click="$emit('help')" class="help">如何获取角色信息?</div>
    </div>
  </Dialog>
</template>

<script>
import Dialog from "@/components/dialog/index.vue";
export default {
  components: {
    Dialog,
  },
  emits: ["close"],
  data() {
    return {
      info: "",
      isOpen: false,
    };
  },
  methods: {
    parse(accountInfo) {
      const KEY = {
        区服ID: "server_id",
        角色ID: "role_id",
        角色名称: "role_name",
        ext: "ext",
      };
      const obj = {};
      accountInfo
        .trim()
        .split("\n")
        .forEach((pair) => {
          const index = pair.indexOf(":");
          const key = pair.slice(0, index);
          const value = pair.slice(index + 1);
          obj[KEY[key.trim()]] = decodeURIComponent(value.trim());
        });
      return obj;
    },
    confirm() {
      if (!this.info) {
        this.$toast("请输入角色信息");
        return;
      }
      const accountObj = this.parse(this.info);
      if (
        !accountObj.server_id ||
        !accountObj.role_id ||
        !accountObj.role_name ||
        !accountObj.ext
      ) {
        this.$toast("请输入正确的角色信息");
        return;
      }
      this.$emit("confirm", accountObj);
      this.isOpen = false;
    },
    open() {
      this.isOpen = true;
    },
    close() {
      this.$emit("close");
      this.isOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.role-input {
  :deep(.outer) {
    .dialog {
      width: 26rem;
      height: 26rem;
      min-width: 26rem;
      background: url(../../../assets/role-input.png) no-repeat center;
      background-size: contain;
    }
  }
  .content {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    .input-area {
      position: relative;
      width: 16.5rem;
      height: 8rem;
      top: 4.5rem;
      box-sizing: border-box;
      padding: 0.5rem;
      textarea {
        resize: none;
        &::placeholder {
          color: #493e86;
        }
        color: black;
        width: 100%;
        height: 100%;
        background: transparent;
        border: none;
        outline: none;
      }
    }
    .btn-area {
      cursor: pointer;
      position: relative;
      top: 7rem;
      width: 5.5rem;
      height: 2.5rem;
    }
    .close-area {
      cursor: pointer;
      position: relative;
      top: 11rem;
      width: 3.5rem;
      height: 3.5rem;
    }
    .help {
      position: relative;
      top: -1rem;
      left: -3.5rem;
      padding: 0.2rem;
      color: #493e86;
    }
  }
}
</style>
